module.exports = __webpack_public_path__ + "img/milan-min.90844a27.jpg";